var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.11 258.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#828282;}.cls-2{fill:#92d050;}.cls-3{fill:#cd80ff;}.cls-4{fill:#ebebeb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.17,6.67c0-2.08,0-4.14.09-6.2H.77v258.7h261C117.08,246.09,4.17,138,4.17,6.67Z",
    transform: "translate(-0.69 -0.47)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.51,174.69A174.22,174.22,0,0,1,87.28.47H.77C.72,2.52.69,4.59.69,6.66c0,131.22,99.68,239.15,227.45,252.22h33.37Z",
    transform: "translate(-0.69 -0.47)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.51,174.69V87.83c-1.31.06-2.63.1-3.95.1A85.46,85.46,0,0,1,172.1,2.47c0-.67,0-1.34.05-2H87.28A174.22,174.22,0,0,0,261.51,174.69Z",
    transform: "translate(-0.69 -0.47)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.15.47c0,.66-.05,1.33-.05,2a85.46,85.46,0,0,0,85.46,85.46c1.32,0,2.64,0,3.95-.1V.47Z",
    transform: "translate(-0.69 -0.47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBackground);
export default __webpack_public_path__ + "static/media/graph_background.7f70741d05c78907ab9ac53a1746d8be.svg";
export { ForwardRef as ReactComponent };